import JwpUploadDialog from './JwpUploadDialog';

export default JwpUploadDialog;
